import React from 'react'
import pic from '../images/qua1.jpg'

export default () => (
  <div className="qualification">
    <img src={pic} />
  </div>
)
